export const DRAWER_WIDTH = 280;
export const COLLAPSED_DRAWER_WIDTH = 72;
/** Shared top green bar height — sidebar brand + GenericHeader */
export const APP_TOP_BAR_HEIGHT = 72;

export const getSidebarState = () => {
  const drawerPaper = document.querySelector('.MuiDrawer-paper');
  if (!drawerPaper) return { isOpen: false, width: 0 };
  
  const drawerWidth = drawerPaper.offsetWidth;
  const isOpen = drawerWidth > COLLAPSED_DRAWER_WIDTH + 10;
  
  return {
    isOpen,
    width: isOpen ? DRAWER_WIDTH : COLLAPSED_DRAWER_WIDTH
  };
};
